import React, { useState } from 'react'
import { Progress } from 'antd'
import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const SUCCESS = 'Password.ok'

type PasswordState = {
  password: string
  errorMsg: string | null
  validateStatus: '' | 'success' | 'error'
}

const FormItemPasswordProgress: React.FC<{ placeholder: string }> = ({
  placeholder,
}) => {
  const [password, setPassword] = useState<PasswordState>({
    password: '',
    errorMsg: null,
    validateStatus: '',
  })
  const [percent, setPercent] = useState(0)
  const { t } = useTranslation()

  const validatePassword = (passwordValue: string): PasswordState => {
    let strength = 0
    let error: string | null = null
    if (passwordValue.length > 8) {
      strength += 25
    } else {
      error = 'Password.error.MinLength'
    }
    if (
      passwordValue.match(/^(?=.*[~`!@#$%^&*()--+={}[\]|\\:"'<>,.?/_₹]).*$/)
    ) {
      strength += 25
    } else {
      error = 'Password.error.SpecialCharacter'
    }
    if (passwordValue.match(/[0-9]+/)) {
      strength += 25
    } else {
      error = 'Password.error.OneNumber'
    }
    if (passwordValue.match(/[a-zA-Z]+/)) {
      strength += 25
    } else {
      error = 'Password.error.OneLetter'
    }

    setPercent(strength)
    return {
      password: passwordValue,
      errorMsg: error,
      validateStatus: strength === 100 ? 'success' : 'error',
    }
  }

  const onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const psw = event.target.value
    setPassword(validatePassword(psw))
  }

  return (
    <>
      <Form.Item
        label={t('Login.NewPassword')}
        name="password"
        validateStatus={password.validateStatus}
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterPassword'),
          },
          {
            validator: () =>
              password.validateStatus === 'success'
                ? Promise.resolve()
                : Promise.reject(new Error(t(password.errorMsg || ''))),
          },
        ]}
      >
        <Input.Password
          tabIndex={7}
          value={password.password}
          placeholder={placeholder}
          autoComplete="off"
          onChange={onPasswordChange}
        />
      </Form.Item>
      {percent > 0 && (
        <Form.Item style={{ marginTop: '-10px' }}>
          <>
            <Progress
              percent={percent}
              className={'progress-' + percent}
              showInfo={false}
            />
            <span
              dangerouslySetInnerHTML={{
                __html: t(password.errorMsg || SUCCESS),
              }}
            />
          </>
        </Form.Item>
      )}
    </>
  )
}

export default FormItemPasswordProgress
